import React from 'react';

export function DoneIcon() {
  return (
    <svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M10.2139 16.3537L16.1185 22.2583L26.635 11.7417" stroke="#888" strokeWidth="4.53" />
    </svg>
  );
}
